/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */

namespace dvs_ui {

   export class PnicDetailsDialogPropertiesViewComponent {

      public bindings: any;
      public controller: any;
      public template: string;

      constructor() {
         this.bindings = {
            data: "<"
         };

         this.controller = PnicDetailsDialogPropertiesViewComponentController;

         this.template = `<vx-property-view class="network-ui-fixed-size-vx-property-view"
                                            data="$ctrl.propertyViewData"/>`;
      }
   }

   class PnicDetailsDialogPropertiesViewComponentController {

      static $inject = [
         "physicalAdapterDetailsViewService"
      ];

      data: any;

      propertyViewData: any;

      constructor(private physicalAdapterDetailsViewService: any) {}

      $onInit(): void {
         this.propertyViewData =
               this.physicalAdapterDetailsViewService.buildOnlyProperties(this.data);
      }
   }

   angular.module("com.vmware.vsphere.client.dvs")
         .component("pnicDetailsDialogPropertiesView",
               new PnicDetailsDialogPropertiesViewComponent ());
}
